import { render, staticRenderFns } from "./CounterpartyGroupPicker.vue?vue&type=template&id=b947b9f2&scoped=true&"
import script from "./CounterpartyGroupPicker.vue?vue&type=script&lang=js&"
export * from "./CounterpartyGroupPicker.vue?vue&type=script&lang=js&"
import style0 from "./CounterpartyGroupPicker.vue?vue&type=style&index=0&id=b947b9f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b947b9f2",
  null
  
)

export default component.exports